// extracted by mini-css-extract-plugin
export default {"textContainer":"TextWithEllipsis__textContainer___zJMXv"};